/**
 * One-time perks bought with Sovereign Shards (see SaveManager.unlockPerk/
 * isPerkUnlocked) — unlike meta upgrades (Echoes, leveled, in metaUpgrades.js)
 * these are binary: bought once, then always on for every future run.
 */

// Was temporarily forced true (every perk treated as owned, regardless of
// purchase) while the Shard economy was being reworked — SHARDS_PER_BOSS
// (Currency.js) was undertuned for a real buy-to-unlock loop, so gating
// perks behind it made the shop unusable. Rebalanced 2026-07-20 (doubled
// per-boss payout, see Currency.js's comment) and flipped back to the
// normal behavior below now that the numbers actually support it.
export const ALL_PERKS_UNLOCKED = false;

export const SHARD_UNLOCKS = {
  doubleDash: {
    id: 'doubleDash',
    name: 'Twin Dash',
    cost: 25,
    description: 'A second dash charge — dash twice before waiting on the shared cooldown.',
  },
  dodgeChance: {
    id: 'dodgeChance',
    name: 'Phase Step',
    cost: 20,
    description: '15% chance to fully dodge incoming damage.',
    value: 0.15,
  },
  extraLife: {
    id: 'extraLife',
    name: 'Second Wind',
    cost: 35,
    description: 'Revive once per run at full HP with a brief invincibility window instead of dying.',
  },
  luckyOdds: {
    id: 'luckyOdds',
    name: "Fortune's Favor",
    cost: 30,
    description: 'Shifts level-up odds to 50% common / 40% uncommon / 10% rare.',
  },
  doubleShards: {
    id: 'doubleShards',
    name: "King's Ransom",
    cost: 40,
    description: 'Bosses drop double Shards.',
  },
  petSecondSlot: {
    id: 'petSecondSlot',
    name: 'Bonded Companion',
    cost: 40,
    description: 'Equip a second pet at once.',
  },
  summonDiscount: {
    id: 'summonDiscount',
    name: 'Bargain Hunter',
    cost: 25,
    description: 'Pet summons cost 50% fewer Shards.',
    value: 0.5,
  },
  luckySummon: {
    id: 'luckySummon',
    name: 'Fated Pull',
    cost: 35,
    description: 'Improves the odds of rolling a Rare-or-better pet on every summon.',
  },
};
